// extracted by mini-css-extract-plugin
export default {"imgdiv":"_230f93f34b _465ca8a132","img":"ababbc0d2d _873eee6873"};